import { useEffect, useState } from "react";

/**
 * Detects mobile / touch devices to disable hover-based 3D interactions.
 * Reveal/entrance animations remain; only pointer-driven tilt is disabled.
 * @param {number} breakpoint Max width (px) considered mobile.
 * @returns {boolean}
 */
export const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const evaluate = () => {
      const isTouch =
        window.matchMedia("(hover: none), (pointer: coarse)").matches;
      const isSmall = window.innerWidth <= breakpoint;
      setIsMobile(isTouch || isSmall);
    };

    evaluate();
    window.addEventListener("resize", evaluate);
    return () => window.removeEventListener("resize", evaluate);
  }, [breakpoint]);

  return isMobile;
};
